import { useCallback, useSyncExternalStore } from 'react';

/** Subscribes to a CSS media query. Returns false during SSR / when matchMedia is unavailable. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== 'function') return () => undefined;
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );
  const getSnapshot = () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/** Below the `lg` breakpoint the sidebar becomes a drawer. */
export const useIsMobile = (): boolean => !useMediaQuery('(min-width: 1024px)');
